<template>
  <div class="info">
    <div class="info__inner">
      Project Name: <b>Bubblegum Sneakers</b><br>
      Total Supply: <b>2000</b><br>
      <br>
      <b>Rules</b>:<br>
      <br>
      - Renounced contract, 0% creator/dev fee, silent launch<br>
      <br>
      - Each token can be returned in exchange for <b>ETH</b>. The amount of <b>ETH</b> is calculated on the formula:
      <br><br>
      <i>ETH in the pool : ( Total Tokens in Circulation x &quot;sold-too-early penalty formula&quot; )<br></i>
      <br>
      - Each returned NFT will be disposed of and removed from circulation forever<br>
      <br>
      - Maximum tokens per wallet are limited to <b>1</b> at launch, every minute the limit increases by <b>1</b><br>
      <br>
      - The last returned token will unlock the entire <b>ETH</b> pool to the final lucky seller<br>
      <br>
      - Each <b>BGS</b> token can be stolen. Be careful and don't forget to check your tokens for stealing claims.<br>
      <br>
      The last returned token will unlock the entire <b>ETH</b> pool to the last seller<br>
      <br>
      Dynamic price from <b>0.05ETH</b> to <b>99.99ETH</b> per piece. Each collected <b>ETH</b> forms a pool and allows users to sell tokens at any moment, however, to protect the holders there is a penalty for selling too early&#160; after the token was minted, initial penalty is set to <b>100%</b> and will be slowly removed after <b>12</b> hours. <br>
      <br>
      Each <b>BGS</b> token can be stolen. Be careful and don't forget to check your tokens for stealing claims. To steal a token you need to lock a <b>BGS</b> token and prepare some <b>ETH</b> that is equals to the actual return price per token. Each steal attempt will last maximum for <b>24 hours</b>. A steal claim can be rejected or ignored, in both cases the <b>ETH</b> goes to the victim, if the claim is ignored then the sneaker will be stolen. Each <b>BGS</b> token has 2 attempts to steal, however, if the second attempt fails then the victim will receive both NFTs and <b>ETH</b>.<br>
      <br>
      Protect and be careful with your <b>BGS</b> tokens, they are very valuable!
    </div>

    <Button :icon="require('@/assets/images/icons/link-2.svg')" class="info__button" @click="onConnectClick">Connect and Accept</Button>
  </div>
</template>

<script setup>
import { connectWallet } from '@/logic/wallet'
import { useLayoutStore } from '@/store'

const layoutStore = useLayoutStore()

async function onConnectClick() {
  await connectWallet()
  layoutStore.closeModal()
}
</script>

<style lang="sass">
.info
  &__inner
    overflow: auto
    animation: fadeIn 0.5s ease
    max-height: 50vh
    padding-right: 12px
    margin-bottom: 12px
    color: #6a6a6a
    font-size: 20px
    letter-spacing: 1.2px

    b
      font-weight: 600
      color: black

    i
      font-style: italic

  @media (screen and max-width: $breakpointMobile)
    &__inner
      max-height: 45vh

</style>